export type ApiErrorResponse = {
  detail: string;
  message: string;
  instance: string;
  properties: {
    code: string;
  };
  status: number;
  title: string;
  type: string;
};

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export type SortQueryParam = {
  field: string;
  direction: SortDirection;
};

export type SpringPageableRequest = {
  page?: number;
  size?: number;
  sort?: SortQueryParam[];
};

export type SpringPage<T> = {
  content: T[];
  pageable: SpringPageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: string;
  numberOfElements: number;
  first: boolean;
  empty: boolean;
};

export type SpringPageable = {
  pageNumber: number;
  pageSize: number;
  sort: SpringSort;
  offset: number;
  paged: boolean;
  unpaged: boolean;
};

export type SpringSort = {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
};
